<script lang="ts" setup>
import CardWithImage from '~/components/cards/CardWithImage.vue'
import ViewAllButton from '~/components/form-elements/ViewAllButton.vue'
import Page from '~/enums/page'
import helpers from '~/helpers'

defineProps<{
  articlesData: any[]
  title: string
}>()

const articlesPath = Page.Articles
</script>

<template>
  <section v-if="articlesData.length">
    <div class="container">
      <Heading element="h2" :path="articlesPath" :title="title" title-class="h1">
        <template #buttons>
          <ViewAllButton title="Все статьи" @click="navigateTo(articlesPath)" />
        </template>
      </Heading>
    </div>

    <Carousel>
      <div class="-ml-2 flex md:-ml-4">
        <div
          v-for="x in articlesData"
          :key="x.id"
          class="flex-[0_0_42.857143%] cursor-pointer pl-2 md:flex-[0_0_33.333333%] md:pl-4 lg:flex-[0_0_25%]"
        >
          <CardWithImage :data="x" :path="helpers.getArticlePath(x)" />
        </div>
      </div>
    </Carousel>
  </section>
</template>
